<sh-form-multi-select
    [id]="id"
    [label]="isHeader ? label : undefined"
    [control]="internalControl"
    [inOverflownContainer]="true"
    [options]="options"
    [searchPlaceholderMsg]="searchPlaceholder"
    [noResultsFoundMsg]="i18n.search.noResultsMsg"
    [listCappedMsg]="i18n.search.listCappedMsg"
    [search]="true"
    [limitHeightToViewport]="true"
></sh-form-multi-select>
